// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { TableFilter, TableFilterSchema } from 'api/gen/TableFilter';

const requiredPart = t.interface({
  fields: t.array(t.string),
  filters: t.union([t.array(TableFilterSchema), t.null]),
});

export const CsvExportParamsSchema = excess(requiredPart);

export interface CsvExportParams extends t.TypeOf<typeof CsvExportParamsSchema> {}
